import JobAppOfferMutations from "./jobAppOffer/jobAppOffer.mutation";
import JobAppOfferQueries from "./jobAppOffer/jobAppOffer.query";

const JobAppOfferServices = {
  ...JobAppOfferQueries,
  ...JobAppOfferMutations,
};

export default JobAppOfferServices;
